"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseStyle = {
    borderColor: 'border',
    borderStyle: 'solid',
    opacity: 1,
};
const mdSize = {
    borderWidth: '1px',
};
const lgSize = {
    borderWidth: '6px',
};
const sizes = {
    lg: lgSize,
    md: mdSize,
};
const defaultProps = {
    size: 'md',
};
const DividerTheme = {
    baseStyle,
    defaultProps,
    sizes,
};
exports.default = DividerTheme;
